export default __webpack_public_path__ + "static/media/nd-bank.f29e00dc.png";